import React from 'react';
import { Stack } from '@mui/material';
import NumericEditTernary from './EditableTypeElements/Numeric/NumericEditTernary';
import TernaryEditComboBox from './EditableTypeElements/ComboBox/TernaryEditComboBox';
import EditTernaryRadCheck from './EditableTypeElements/RadCheck/EditTernaryRadCheck';
import EditableCustomCheckBox from '../EditableCustomCheckBox.js/EditableCustomCheckBox';
import DatePickerEditTernary from './EditableTypeElements/DatePicker/DatePickerEditTernary';
import EditableSingularTimePicker from '../EditableSingularTimePicker/EditableSingularTimePicker';
import EditableDataGridView from '../EditableDataGridView/EditableDataGridView';
import ComponentMemoizer from 'Global/Components/ComponentMemoizer/ComponentMemoizer';
import { standardizeEditGrid } from '../EditableDataGridView/components/functions/standardizeEditGrid/standardizeEditGrid';
import EditableRichTextInput from '../EditableRichTextInput/EditableRichTextInput';
import EditablePictureBoxWithEditor from '../EditablePictureBoxWithEditor/EditablePictureBoxWithEditor';
import ControllerWrapper from 'Global/Components/Generators/FormElementCreatorByType/components/ControllerWrapper/ControllerWrapper';
import EditableElectronicFormRadioGenerator from 'Global/Components/Generators/EditableElectronicFormRadioGenerator/EditableElectronicFormRadioGenerator';
import EditablePersianSupportTextField from '../EditablePersianSupportTextField/EditablePersianSupportTextField';
import MemoEditableGrid from './MemoEditableGrid';
import { useLocation } from 'react-router-dom';
import i18next from 'i18next';
import EditableTextArea from '../EditableTextArea/EditableTextArea';
import { useAtom } from 'jotai';
import { surveyDisableEditAtom } from 'Global/shared/survey.disabel.edit.atom';

const EditElementTypeMatcher = ({
  element,
  field,
  control,
  errors,
  setValue,
}) => {
  const [surveyDisable] = useAtom(surveyDisableEditAtom);
 
  return (
    <React.Fragment>
      {Array.isArray(field) ? (
        <EditableElectronicFormRadioGenerator
          element={field}
          setValue={setValue}
          control={control}
          errors={errors}
          initialValue={field}
        />
      ) : field.element?.ElsRecord?.Type === 'TextBox' ? (
        <ControllerWrapper
          control={control}
          errors={errors}
          field={field}
          element={
            <EditablePersianSupportTextField
              label={field.element?.LablelNameForWeb}
              isEnglish={
                !surveyDisable
                  ? i18next.language === 'en'
                  : true
              }
              enableSuggest={[field.element?.ElsRecord?.Id]}
              element={field.element}
              Initialvalue={field.value || ''}
              isMultiLine={true}
            />
          }
        />
      ) : field.element?.ElsRecord?.Type === 'ComboBox' ? (
        <ControllerWrapper
          control={control}
          errors={errors}
          field={field}
          element={
            <TernaryEditComboBox
              field={field}
              element={field.element}
            />
          }
        />
      ) : field.element?.ElsRecord?.Type === 'Date' ? (
        <ControllerWrapper
          control={control}
          errors={errors}
          field={field}
          element={
            <DatePickerEditTernary
              field={field}
              element={field.element}
            />
          }
        />
      ) : field.element?.ElsRecord?.Type === 'Time' ? (
        <ControllerWrapper
          control={control}
          errors={errors}
          field={field}
          element={
            <EditableSingularTimePicker
              isEnglish={true}
              label={element?.LablelNameForWeb}
              initalValue={field?.UiValue?.Value}
            />
          }
        />
      ) : field.element?.ElsRecord?.Type ===
        'RadCheckedDropDownList' ? (
        <ControllerWrapper
          control={control}
          errors={errors}
          field={field}
          element={
            <EditTernaryRadCheck
              field={field}
              element={field.element}
            />
          }
        />
      ) : field.element?.ElsRecord?.Type === 'CheckBox' ? (
        <ControllerWrapper
          control={control}
          errors={errors}
          field={field}
          element={
            <EditableCustomCheckBox
              label={field.element?.LablelNameForWeb}
              defaultChecked={Number(field.value) > 0}
              element={field}
              setValue={setValue}
              control={control}
              errors={errors}
            />
          }
        />
      ) : field.element?.ElsRecord?.Type === 'Numeric' ? (
        <ControllerWrapper
          control={control}
          errors={errors}
          field={field}
          element={
            <NumericEditTernary
              field={field}
              element={field.element}
            />
          }
        />
      ) : field.element?.ElsRecord?.Type ===
        'DataGridView' ? (
        <Stack spacing={1}>
          <ControllerWrapper
            control={control}
            errors={errors}
            field={field}
            element={
              <MemoEditableGrid
                element={element}
                field={field}
              />
            }
          />
        </Stack>
      ) : field.element?.ElsRecord?.Type ===
        'PictureBox' ? (
        // <EditableFileUploaderDropZone
        //   onChange={onChange}
        //   label={element?.LablelNameForWeb}
        //   isEnglish={true}
        //   initialImage={field.base64}
        // />
        <ControllerWrapper
          control={control}
          errors={errors}
          field={field}
          element={
            <EditablePictureBoxWithEditor
              element={element}
              initialImage={field.base64}
              field={field}
            />
          }
        />
      ) : field.element?.ElsRecord?.Type === 'RashenWord' ||
        field.element?.ElsRecord?.Type === 'RichTextBox' ||
        field.element?.ElsRecord?.Type ===
          'RashenRichTextBoxNormal' ? (
        <ControllerWrapper
          control={control}
          errors={errors}
          field={field}
          element={
            <EditableRichTextInput
              element={field.element}
              field={field}
              enableSuggest={[field.element?.ElsRecord?.Id]}
            />
          }
        />
      ) : field.element?.ElsRecord?.Type ===
        'RichTextBoxExtended' ? (
        <EditableTextArea
          label={field.element?.LablelNameForWeb}
          isEnglish={
            !surveyDisable
              ? i18next.language === 'en'
              : true
          }
          enableSuggest={[field.element?.ElsRecord?.Id]}
          element={field.element}
          Initialvalue={field.value || ''}
          isMultiLine={true}
        />
      ) : (
        console.log('->', field.element)
      )}
    </React.Fragment>
  );
};
export default React.memo(EditElementTypeMatcher);

// <CustomizableSelect
//           onChange={onChange}
//           SelectableDataArray={StructureAnswersForSelectables(
//             element?.ElsRecord?.ListDefaultAnswer,
//             "RadCheckedDropDownList"
//           )}
//           label={element?.LablelNameForWeb}
//           isEnglish={false}
//           swipleToLeftTitle={true}
//           CompleteOutPut={true}
//         />

{
  /* <EditableCustomizableSelect initialData={UiItem.value} /> */
}
